import * as React from "react";
import { Button, Grid, Typography } from "@material-ui/core";

import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
// import { Box } from "@mui/system";
import Box from '@mui/material/Box';
import { useHistory, Redirect } from "react-router-dom";
import successTick from "../../../utils/assests/successTik.png";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import Header from "../../../Common/header";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    boxRoot: {
      "@media (min-width: 1280px)": {
        height: "100vh",
        padding: "10px",
        border: "1px transparent grey",
        boxShadow: "0 24px 55px 10px rgb(13 12 12 / 30%)",
        borderRadius: "5px",
      },
      [theme.breakpoints.down("xs")]: {
        height: "100vh",
        padding: "10px",
      },
      [theme.breakpoints.between("sm", "md")]: {
        height: "100vh",
        padding: "10px",
      },
    },
    img: {
      margin: "70px 0px 40px 0px",
    },
    root: {
      padding: "5px 45px",
      borderRadius: "19px",
      backgroundColor: "#DA222C",
      color: "#fff",
      margin: "25px",
    },
  })
);

export default function Congratulations() {
  const classes = useStyles();
  const history = useHistory();
  const historyState: any = history.location.state;

  // if(historyState==undefined) {
  //     history.push('/dashboard');
  // }

  const onClickButton = async () => {
    history.push("/offers", {
      cd_loans: historyState?.cd_loans,
      application_id: historyState?.application_id,
    });
  };
  return (
    <div>
      <div>
        <Header pageName="" />
      </div>

      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={6} md={3} lg={3}>
            <Box
              className="congratulationPage"
              component="div"
              textAlign="center"
              sx={{ px: 4 }}
            >
              <Box component="div">
                <img
                  src={successTick}
                  className={classes.img}
                  alt="pending status"
                />
              </Box>
              <Box component="div">
                <Typography variant="h1">{"Congratulations!"}</Typography>

                <Typography>
                  {"You are eligible for a credit limit up to"}
                  {/* <Typography variant="h5" style={{ fontWeight: 'bold' }}>{historyState?.selected_offer}</Typography> */}
                </Typography>
                <Typography variant="h2">
                  ₹{historyState?.cd_loans[0].offer_amount}
                </Typography>
                <Typography>
                  {`Select your offer plan and get your offer `}
                  <strong>Today!</strong>
                </Typography>
              </Box>

              <Box textAlign="center" mt={8}>
                <Button
                  variant="contained"
                  color="secondary"
                  className="redButton"
                  onClick={() => onClickButton()}
                >
                  {"Continue"}
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
